"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCFChallenge = void 0;
var turnstileInstance = null;
exports.handleCFChallenge = function (challengeResponse, sdkClient) { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
    var document_1, challengeWrapper_1, challengeDiv_1, showChallenge_1, cloudflareScript;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        try {
            document_1 = window === null || window === void 0 ? void 0 : window.document;
            if (!document_1 || !window) {
                throw new Error('document is not present on window');
            }
            challengeWrapper_1 = document_1.createElement('div');
            challengeDiv_1 = document_1.createElement('div');
            showChallenge_1 = function (turnstile) {
                var _a;
                (_a = turnstile === null || turnstile === void 0 ? void 0 : turnstile.render) === null || _a === void 0 ? void 0 : _a.call(turnstile, "#iDonateTurnstileBox", {
                    sitekey: sdkClient.config.turnstileSiteKey,
                    callback: function (token, preClearance) {
                        challengeWrapper_1.remove();
                        resolve({ token: token, preClearance: preClearance });
                    },
                });
            };
            window.idonateTurnstileLoadedHandler = function () {
                var turnstile = window.turnstile;
                challengeDiv_1.innerHTML = '';
                if (turnstile) {
                    turnstileInstance = turnstile;
                }
                showChallenge_1(turnstile);
            };
            challengeWrapper_1.setAttribute('id', 'idonateTurnstileWrapper');
            challengeWrapper_1.style.position = 'fixed';
            challengeWrapper_1.style.top = '0';
            challengeWrapper_1.style.bottom = '0';
            challengeWrapper_1.style.left = '0';
            challengeWrapper_1.style.right = '0';
            challengeWrapper_1.style.backgroundColor = 'rgba(0,0,0,0.9)';
            challengeWrapper_1.style.transition = 'all 400ms';
            challengeWrapper_1.style.display = 'flex';
            challengeWrapper_1.style.flexDirection = 'column';
            challengeWrapper_1.style.padding = '40px 30px';
            challengeWrapper_1.style.opacity = '0';
            challengeWrapper_1.style.color = 'white';
            challengeWrapper_1.style.fontFamily = 'sans-serif';
            challengeWrapper_1.style.zIndex = '1000';
            challengeWrapper_1.innerHTML = '<h1 id="idonateTurnstileVerificationHeader">Last tiny step before we submit your payment:</h1>';
            challengeDiv_1.setAttribute('id', 'iDonateTurnstileBox');
            challengeWrapper_1.append(challengeDiv_1);
            document_1.body.append(challengeWrapper_1);
            if (turnstileInstance) {
                showChallenge_1(turnstileInstance);
            }
            else {
                cloudflareScript = document_1.createElement('script');
                challengeDiv_1.innerHTML = 'loading ...';
                cloudflareScript.src = sdkClient.config.turnstileCdnUrl + '?render=explicit&onload=idonateTurnstileLoadedHandler';
                document_1.body.append(cloudflareScript);
            }
            (_a = challengeDiv_1.scrollIntoView) === null || _a === void 0 ? void 0 : _a.call(challengeDiv_1);
            challengeWrapper_1.style.opacity = '1';
        }
        catch (e) {
            (_b = console === null || console === void 0 ? void 0 : console.error) === null || _b === void 0 ? void 0 : _b.call(console, e);
            (_c = console === null || console === void 0 ? void 0 : console.warn) === null || _c === void 0 ? void 0 : _c.call(console, 'iDonate SDK: Could not handle request, please reload the page and try again');
            reject(null);
        }
        return [2];
    });
}); }); };
